module.exports = __webpack_public_path__ + "img/abbLabel.011ff5dd.jpg";